import type {
  ProcessEventMutation,
  ProcessEventMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const PROCESS_EVENT: TypedDocumentNode<
  ProcessEventMutation,
  ProcessEventMutationVariables
> = gql`
  mutation ProcessEvent($input: ProcessEventInput!) {
    processEvent(input: $input) {
      success
      message
      error
    }
  }
`;
